(function(angular, floor, pow) {
    'use strict';

    // in PRM these are the formats for the observation value measurements:
    // (According to FrameworkBO.Util.Observation.ObservationFormatter)
    // ====================================================================
    // 1. public const string MetricWeightMask = "####0.000";
    var kgPrecision = 3;

    // 2. public const string EnglishPoundMask = "####0.000";
    // this will always be converted to an integer, because the ounces will have the fractional amount

    // 3. public const string EnglishOzMask = "###0.0";
    // the precision of oz is 1 regardless of this mask declared in PRM, because the conversion code rounds
    // to a precision of 1
    var ozPrecision = 1;

    // 4. public const string MetricCMMask = "####0.000";
    var cmPrecision = 3;

    // 5. public const string EnglishFeetMask = "####0";
    // this will always be converted to an integer, because the inches will have the fractional amount

    // 6. public const string EnglishInchMask = "###0.000";
    // the precision of in is 1 regardless of this mask declared in PRM, because the conversion code rounds
    // to a precision of 1
    var inPrecision = 1;
    // ======================================================================


    // Multipliers:
    // 1 lb ~= 0.45359237 kg
    var lbsToKgMultiplier = 0.45359237;
    // 1 oz ~= 0.0283495231 kg
    var ozToKgMultiplier = 0.0283495231;

    // 1 kg ~= 2.2046226218 lbs
    var kgToLbsMultiplier = 2.2046226218;
    // 1 lb == 16 oz
    var lbsToOzMultiplier = 16;

    // 1 ft ~= 30.48 cm
    var ftToCmMultiplier = 30.48;
    // 1 in ~= 2.54 cm
    var inToCmMultiplier = 2.54;

    // 1 cm ~= 0.032808399 ft
    var cmToFtMultiplier = 0.032808399;
    // 1 ft == 12 in
    var ftToInMultiplier = 12;

    angular.module('aprima-core').factory('UnitConvert', [
        '_',
        'NumUtil',
        UnitConvert,
    ]);

    function UnitConvert(
        _,
        NumUtil
    ) {

        var service = {
            usToKg: convertUsToKg,
            usToKgRounded: convertUsToKgRounded,
            roundKg: roundKg,
            usToCm: convertUsToCm,
            usToCmRounded: convertUsToCmRounded,
            roundCm: roundCm,
            kgToUs: convertKgToUs,
            kgToUsRounded: convertKgToUsRounded,
            cmToUs: convertCmToUs,
            cmToUsRounded: convertCmToUsRounded,
            getBodySurfaceArea: getBodySurfaceArea,
        };

        return service;

        function convertUsToKg(lbs, oz) {
            var totalKg = NumUtil.add(NumUtil.multiply((lbs || 0), lbsToKgMultiplier), NumUtil.multiply((oz || 0), ozToKgMultiplier));
            return totalKg;
        }

        function convertUsToKgRounded(lbs, oz) {
            var roundedKg = roundKg(convertUsToKg(lbs, oz));
            return roundedKg;
        }
        
        function roundKg(kg) {
            var roundedKg = _.round(kg, kgPrecision);
            return roundedKg;
        }

        function convertUsToCm(ft, inches) {
            var totalCm = NumUtil.add(NumUtil.multiply((ft || 0), ftToCmMultiplier), NumUtil.multiply((inches || 0), inToCmMultiplier));
            return totalCm;
        }

        function convertUsToCmRounded(ft, inches) {
            var roundedCm = roundCm(convertUsToCm(ft, inches));
            return roundedCm;
        }
        
        function roundCm(cm) {
            var roundedCm = _.round(cm, cmPrecision);
            return roundedCm;
        }

        function convertKgToUs(kg) {
            var totalPounds = NumUtil.multiply((kg || 0), kgToLbsMultiplier);
            var lbs = floor(totalPounds);
            var oz = NumUtil.multiply(NumUtil.subtract(totalPounds, lbs), lbsToOzMultiplier);

            var result = {
                pounds: lbs,
                ounces: oz,
            };

            return result;
        }

        function convertKgToUsRounded(kg) {
            var usMeasurements = convertKgToUs(kg);
            usMeasurements.ounces = _.round(usMeasurements.ounces, ozPrecision);
            return usMeasurements;
        }

        function convertCmToUs(cm) {
            var totalFeet = NumUtil.multiply((cm || 0), cmToFtMultiplier);
            var ft = floor(totalFeet);
            var inches = NumUtil.multiply(NumUtil.subtract(totalFeet, ft), ftToInMultiplier);

            var result = {
                feet: ft,
                inches: inches,
            };

            return result;
        }

        function convertCmToUsRounded(cm) {
            var usMeasurements = convertCmToUs(cm);
            usMeasurements.inches = _.round(usMeasurements.inches, inPrecision);
            return usMeasurements;
        }
        
        // Returns the body surface area as calculated using the DuBois formula method.
        function getBodySurfaceArea(heightCm, weightKg) {
            if(!heightCm || !weightKg) {
                return 0;
            }
            
            // body surface area = 0.007184 * height(cm) to the 0.725 power * weight(kg) to the 0.425 power.
            var bsa = NumUtil.multiply(0.007184, pow(heightCm, 0.725), pow(weightKg, 0.425));
            return bsa;
        }
    }

})(window.angular, window.Math.floor, window.Math.pow);
